import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactBootstrapModal } from '@paysera/react-common';
import CandidateApply from '../components/CandidateApply';
import { Apply } from '../../shared/components';

export const ApplyAsCandidateModal = () => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    return (
        <ReactBootstrapModal
            backdrop
            Title={() => t('apply_form.apply_as_candidate')}
            Body={({ hideModal }) => (
                <CandidateApply
                    hideModal={hideModal}
                    onSuccess={() => hideModal()}
                />
            )}
        >
            {({ showModal }) => <Apply text={t('apply_form.apply_as_candidate')} showModal={showModal} />}
        </ReactBootstrapModal>
    );
}
